import { render, staticRenderFns } from "./CombinationsConfiguratorCanvasHero.vue?vue&type=template&id=64e9730c&scoped=true"
import script from "./CombinationsConfiguratorCanvasHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorCanvasHero.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9730c",
  null
  
)

export default component.exports